module.exports = __webpack_public_path__ + "static/media/icon-event-todo.839ade44.svg";